import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ResponsiveImage from '@artemis/components/ResponsiveImage';

const BackLinkWrapper = styled.a`
  align-content: center;
  display: flex;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.common.black};
`;

const BackButtonWrapper = styled.button`
  align-content: center;
  display: flex;
  text-decoration: none;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.palette.common.black};
  padding: 0;
  cursor: pointer;
`;

const BackIcon = styled(ResponsiveImage)`
  display: flex;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin: auto 0;
  margin-right: 12px;
`;

const BackLink = ({ url, onClick, children }) => {
  if (!url && !onClick) {
    return null;
  }

  if (onClick) {
    return (
      <BackButtonWrapper onClick={onClick}>
        <BackIcon id="back.svg.img" />
        <div>{children}</div>
      </BackButtonWrapper>
    );
  }

  return (
    <BackLinkWrapper href={url}>
      <BackIcon id="back.svg.img" />
      <div>{children}</div>
    </BackLinkWrapper>
  );
};

BackLink.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default BackLink;
